export default "__VITE_ASSET__CZ_505Vn__"